import { GridColumnDef } from 'ng2-app/models/businesses/GridColumnDef.model';

export class InitColumns {
    static readonly type = '[Columns] InitColumns';
    constructor(
        public path: string
    ) {}
}

export class UpdateColumnData {
    static readonly type = '[Columns] UpdateColumnData';
    constructor(
        public list: GridColumnDef
    ) {}
}
